<template>
	<div class="pages" v-loading="listLoading">
		<div v-for='(item,index) in templateData.TemplateContent.Controls' :key='index'>
			<Digit v-if='item.Property.Control=="Number"' :data-val='item'></Digit>
			<Contact v-if='item.Property.Control=="Condition"' :data-val="item"></Contact>
			<Dates v-if='item.Property.Control=="Date"' :data-val="item"></Dates>
			<Version v-if='item.Property.Control=="Text"' @child-event='getTextVal' :data-val="item"></Version>
			<Money v-if='item.Property.Control=="Money"' :data-val="item"></Money>
			<Tips v-if='item.Property.Control=="Tips"' :data-val="item"></Tips>
			<File v-if='item.Property.Control=="File"' :data-val="item"></File>
			<Table v-if='item.Property.Control=="Table"' @child-event='tableOperation' :data-val='item'></Table>
			<Selector v-if='item.Property.Control=="Selector"' @child-event='getSelectorVal' :data-val='item'></Selector>
			<Textarea v-if='item.Property.Control=="Textarea"' :data-val='item'></Textarea>
		</div>
		<Button class="submit-process" v-on:click='submit' v-bind:disabled="isDisabled" v-bind:loading="formLoading" size="large" type="primary"> 提交
		</Button>
	</div>
</template>

<script>
	/**
	 * Version 为Text文本组件
	 */
	import Digit from '../components/Number.vue'
	import Contact from '../components/Contact.vue';
	import Dates from '../components/Date.vue';
	import Version from '../components/Text.vue';
	import Money from '../components/Money.vue';
	import Tips from '../components/Tips.vue';
	import File from '../components/File.vue';
	import Table from '../components/Table.vue';
	import Selector from '../components/Selector.vue';
	import Textarea from '../components/Textarea.vue';
	import Choose from '../components/Choose.vue'
	import wx from 'weixin-js-sdk'

	import stringUtils from "../assets/js/stringUtil.js";

    import { getTemplateInfo,submitProcess } from '@/api/approval'
	import {
		getRelation
	} from '@/api/employee'

	var isSubmit = false;

	var template = {
		TemplateContent: {
			Controls: []
		}
	};
	export default {
		components: {
			Contact,
			Dates,
			Version,
			Money,
			Tips,
			File,
			Table,
			Digit,
			Selector,
			Textarea,
		},
		data() {
			return {
				templateData: template,
				relationList: null,
				logInfo: null,
				templateId: "",
				spNo: null,
				listLoading: false,
				isDisabled: false,
				formLoading:false
			}
		},
		created() {
      console.log(1)
			this.logInfo = this.getLoginUserInfo();
			this.templateId = this.$route.query.templateId;
			this.spNo = this.$route.query.spNo;
			this.getTemplate();
			stringUtils.setAddIsShow(false);
		},
		methods: { //方法
			getTemplate:async function() {
			  const that = this
				this.listLoading = true;
        console.log(this.logInfo)
				const {EmpNo,DeptName,EmpName,fullName} = this.logInfo
        await this.getEmployeeRelation()
				await getTemplateInfo(this.templateId).then(async response => {
					var controls = response.Body;
					for (const item of controls.TemplateContent.Controls) {
						const name = item.Property.Title[0].Text
						let v
						switch (name) {
							case "申请部门":
								item.Value = DeptName
								item.isDisabled = true
								break
							case "申请人":
								item.Value = EmpName
								item.isDisabled = true
								break
							case "逐级审批使用":
								item.Values = await that.getRelationList(this.relationList, 10);
								v = item.Values.filter(e => e[0] === "SC24000029")
								if ((fullName.indexOf("代理") > -1 || fullName.indexOf("原友信") > -1 || fullName.indexOf("藤云") > -1 || fullName.indexOf("按揭金融服务中心") > -1)
								&& v.length === 0){
									item.Values.push(this.$store.state.defaultMember)
								}
								for(var i=0;i<item.Values.length;i++){
									if(item.Values[i][0]==="SC24000029"){
										// 在前面插入默认审批人
										item.Values.splice(i,0,["SC09120024","聂丽娟"])
										break
									}
								}
								console.log(item.Values)
								item.IsShow = false
								break
						}
					}
          this.templateData = this.assignControl(controls, this.logInfo);
					this.templateData = await this.assignControlBySpNo(controls, this.spNo);
					this.listLoading = false;
				});
			},
			async getEmployeeRelation() {
        await getRelation(this.logInfo.EmpNo).then(response => {
          const body = response.Body.filter(e => e.FlagPrimary === 1)[0]
					this.relationList = body.Nodes;
				});
			},
			getTextVal() {},
			getSelectorVal(val, name,datas) {
				console.log(val);
				this.$forceUpdate()
			},
			tableOperation(val, type, datas) {
				this.tableoperation(val, type, datas, this);
			},
			submit() {
				//数据校验
				if (!this.submitValidate(this.templateData.TemplateContent.Controls)) {
					return;
				}
        let val = this.templateData.TemplateContent.Controls.filter(e => e.Property.Title[0].Text === "经办人陈述")[0].Value
				if (val.length > 2500){
				  this.Message({
            message: "经办人陈述最多可填写2500个字,请检查后重试",
            type: 'error',
            duration: 1000
          })
          return;
        }
				if (isSubmit) {
					this.Message({
						message: '已提交',
						type: 'warning',
						duration: 1000
					});
					return;
				}
				isSubmit = true;
				this.formLoading=true;
				
				var SummaryList = [];
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				info.SummaryInfo.push({"Text":"申请人信息："+" "+this.logInfo.EmpName+" "+this.logInfo.EmpNo+" "+this.logInfo.DeptName,"Lang":"zh_CN"});
				SummaryList.push(info);
				this.templateData.SummaryList=SummaryList;
				
				//提交
				submitProcess(this.templateId, this.logInfo.EmpNo, this.spNo, this.templateData).then(response => {
					this.Message({
						message: '申请成功',
						type: 'success',
						duration: 3*1000
					});
					setTimeout(()=>{this.$router.push("/index");},3000)
				}).finally(()=>{
					isSubmit = false;
					this.formLoading=false;
				});
			}
		},
	}
</script>

<style scoped lang="less">
	.pages {
		padding-bottom: 14px;
	}
</style>
